import type { JSX } from 'react'

import { TextBoxFontSmBold } from 'atoms/TextBox/Templates/TextBoxFontSmBold'
import { TextBoxFontSmSecondary } from 'atoms/TextBox/Templates/TextBoxFontSmSecondary'
import { SettingsNestedPageTextBlockSC } from './SettingsNestedPageTextBlock.styled'

export interface ISettingsNestedPageTextBlockProps {
  creditsText?: string
  creditsLabel?: string
}

export function SettingsNestedPageTextBlock({
  creditsText,
  creditsLabel,
}: ISettingsNestedPageTextBlockProps): JSX.Element {
  return (
    <SettingsNestedPageTextBlockSC>
      <TextBoxFontSmSecondary title={creditsText} />{' '}
      <TextBoxFontSmBold title={creditsLabel} />
    </SettingsNestedPageTextBlockSC>
  )
}
